import { UploadedFile } from "@/pages/SimulInter/components/SpeechDraftView";

const downloadFileFromUrl = async (url: string): Promise<UploadedFile | null> => {
  // 发起网络请求下载文件
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`下载失败: ${response.status} ${response.statusText}`);
  }

  // 获取文件信息
  const contentType = response.headers.get("content-type") || "";
  const contentDisposition = response.headers.get("content-disposition") || "";

  // 从URL或Content-Disposition头中提取文件名
  let fileName = "downloaded-file";

  // 尝试从Content-Disposition头获取文件名
  if (contentDisposition) {
    // 处理多种Content-Disposition格式
    const filenameMatch = contentDisposition.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    );
    const filenameStarMatch = contentDisposition.match(
      /filename\*=UTF-8''([^;\n]*)/
    );

    if (filenameStarMatch && filenameStarMatch[1]) {
      // 处理 filename*=UTF-8''xxx 格式
      fileName = decodeURIComponent(filenameStarMatch[1]);
    } else if (filenameMatch && filenameMatch[1]) {
      // 处理 filename="xxx" 或 filename=xxx 格式
      fileName = filenameMatch[1].replace(/['"]/g, "");
      // 如果是URL编码的，尝试解码
      try {
        fileName = decodeURIComponent(fileName);
      } catch (e) {
        // 解码失败，使用原始值
      }
    }
  }

  // 如果从Content-Disposition获取失败，尝试从URL中提取
  if (fileName === "downloaded-file") {
    // 从URL参数中查找filename
    const urlObj = new URL(url);
    const filenameParam =
      urlObj.searchParams.get("filename") ||
      urlObj.searchParams.get("response-content-disposition");

    if (filenameParam) {
      // 从参数中提取文件名
      const paramMatch = filenameParam.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      );
      if (paramMatch && paramMatch[1]) {
        fileName = paramMatch[1].replace(/['"]/g, "");
        try {
          fileName = decodeURIComponent(fileName);
        } catch (e) {
          // 解码失败，使用原始值
        }
      }
    } else {
      // 从URL路径中提取文件名
      const urlParts = url.split("/");
      const lastPart = urlParts[urlParts.length - 1];
      if (lastPart && lastPart.includes(".")) {
        fileName = decodeURIComponent(lastPart.split("?")[0]); // 移除查询参数
      }
    }
  }

  // 获取文件数据
  const blob = await response.blob();

  // 确定文件类型
  const extension = fileName.split(".").pop()?.toLowerCase();
  let fileType: UploadedFile["type"];

  switch (extension) {
    case "pdf":
      fileType = "pdf";
      break;
    case "docx":
      fileType = "docx";
      break;
    case "doc":
      fileType = "doc";
      break;
    case "txt":
      fileType = "txt";
      break;
    default:
      // 根据Content-Type判断
      if (contentType.includes("pdf")) {
        fileType = "pdf";
      } else if (contentType.includes("wordprocessingml")) {
        fileType = "docx";
      } else if (contentType.includes("msword")) {
        fileType = "doc";
      } else if (contentType.includes("text/plain")) {
        fileType = "txt";
      } else {
        throw new Error(`不支持的文件类型: ${extension || contentType}`);
      }
  }

  // 创建File对象
  const file = new File([blob], fileName, {
    type: blob.type || contentType,
  });

  // 创建本地预览URL
  const localUrl = URL.createObjectURL(blob);

  // 创建UploadedFile对象
  const uploadedFile: UploadedFile = {
    file,
    url: localUrl,
    type: fileType,
    name: fileName,
    size: blob.size,
  };

  console.log("文件下载成功:", {
    name: fileName,
    size: blob.size,
    type: fileType,
    contentType,
  });

  return uploadedFile;
};

export default downloadFileFromUrl;